import { countriesAlpha2 } from '@sequencehq/api/commonEnums'

/**
 * Shown wherever a customer's address would go when they have none, so the
 * invoice, credit note and customer views all name the gap the same way.
 */
export const NO_ADDRESS_LABEL = 'No address added'

export const taxStatusOptions = {
  TAXED: 'Taxed',
  TAX_EXEMPT: 'Tax exempt',
  REVERSE_CHARGED: 'Reverse charged'
}

export const countriesOptions = Object.entries(countriesAlpha2).map(
  ([value, label]) => ({
    value,
    label
  })
)
